document.addEventListener('DOMContentLoaded', function(){

	/* Global constants
	==================================== */
	const
		b = $('body'),
		cursor = $('#cursor');

	/* Easing
	==================================== */
	const
		speed  = 300,
		speed2 = 400,
		ease   = 'easeInOutQuart';

	/* Init
	==================================== */
	function heightViewport(){
		document.documentElement.style.cssText = `
			--height-viewport: ${window.innerHeight}px;
			--height-viewport-small: ${window.innerHeight - $('header').outerHeight(true)}px;
		`;
	}

	/* Slider Desktop
	==================================== */
	const $F = $('.module-slider.slider .slider-track');
	function showItems(items_active, items_target, button, time){
		if(items_active.length){
			items_active.fadeOut(time, function(){
				items_target.fadeIn(time)
			})
		}else{
			if(button.length && button.is(':visible')){
				button.fadeOut(time, function(){
					items_target.fadeIn(time)
				})
			}else{
				items_target.fadeIn(time)
			}
		}
	}
	function showSoundButton(button, video, items_active, time){
		if(button.length){
			if(video.is('video') && video.hasClass('sound')){
				if(items_active.length){
					items_active.fadeOut(time, function(){
						button.fadeIn(time)
					})
				}else{
					button.fadeIn(time)
				}
			}else{
				if(button.is(':visible')){
						button.fadeOut(time, function(){
							button
								.removeClass('active')
								.find('[data-lang="en"]').text('SOUND ON')
								.next().text('ACTIVER LE SON')
						})
				}
			}
		}
	}
	function navSlider(active, target, direction){
		if($F.length && !$F.hasClass('transition')){

			if(window.innerWidth > 834){

				if(direction == 'next' && !active.hasClass('last') && !active.next().hasClass('last') ||
					direction == 'prev' && !active.hasClass('first') && !active.next().hasClass('first')){

					$F.addClass('transition');

					active.fadeOut(speed*2, function(){
						$(this).removeClass('active')
					}).next().fadeOut(speed*2)

					target.fadeIn(speed*2, function(){
						$(this).addClass('active')
						$F.removeClass('transition');
					}).next().fadeIn(speed*2)

					//Nav
					var next = $F.parent().find('.next');
					if(target.hasClass('last') || target.next().hasClass('last')){
						next.addClass('inactive')
							 .find('span').hide()
							 .siblings('a').show()
					}else{
						next.removeClass('inactive')
							 .find('span').show()
							 .siblings('a').hide(speed)
					}
					var prev = $F.parent().find('.prev');
					if(target.hasClass('first') || target.next().hasClass('first')){
						prev.addClass('inactive')
							 .find('span').hide()
							 .siblings('a').show()
					}else{
						prev.removeClass('inactive')
							 .find('span').show()
							 .siblings('a').hide()
					}

					//Videos
					var videos = [target.find('.thumb'), target.next().find('thumb')]
					if($('.module-slider.slider video').length){
						$('.module-slider.slider  video').not(videos).each(function(){
							$(this)[0].pause()
							$(this).prop('muted', true)
						});
					}
					if($('.module-slider.slider video').length){
						if(target.find('.thumb').is('video')){
							target.find('.thumb')[0].play();
						}
						if(target.next().find('.thumb').is('video')){
							target.next().find('.thumb')[0].play();
						}
					}

					//Count
					var count = target.next().data('pos')/2;
					$F.parent().find('.slider-count span').text(count);

					//Items
					var time = speed,
						 items_active = $F.parent().find('.slider-footer_item:visible'),
						 items_target = $F.parent().find(
												'.slider-footer_item[data-pos="'+target.data('pos')+'"], .slider-footer_item[data-pos="'+target.next().data('pos')+'"]'
											),
						 video = target.find('.thumb'),
						 button = target.parents('.module-slider').find('.trigger-sound');
					showItems(items_active, items_target, button, time)
					showSoundButton(button, video, items_active, time)

				}

			}
		}
	}
	function nextSlideFade(){
		var active = $('.slider .slide.active'),
			 target = active.next().next(),
			 direction = 'next';
		navSlider(active, target, direction)
	}
	function prevSlideFade(){
		var active = $('.slider .slide.active'),
			 target = active.prev().prev(),
			 direction = 'prev';
		navSlider(active, target, direction)
	}

	/* Slider Mobile
	==================================== */
	const $S = $('.slider-mobile .slider-track');
	function pauseVideos(video){
		if($('.slider-mobile:not(.module-carrousel).focus video').length){
			$('.slider-mobile:not(.module-carrousel).focus video').not(video).each(function(){
				$(this)[0].pause();
				$(this).prop('muted', true);
			});
		}
	}
	function playVideos(video){
		if($('.slider-mobile:not(.module-carrousel).focus video').length){
			if(video.is('video')){
				video[0].play();
			}
		}
	}
	function nextSlide(){
		$S.each(function(){
			var t = $(this);
			if(t.length && t.parent().hasClass('focus') && !t.hasClass('transition')){
				var slide = t.find('.slide:first-child'),
					 video = slide.next().find('.thumb');

				t.addClass('transition')
				 .animate({
					'left': '-100%'
				}, speed2, ease, function(){
					t.append(slide)
					 .css('left', '0')
					 .removeClass('transition');
					pauseVideos(video)
				});
				playVideos(video)

				//Count
				t.parent().find('.slider-count span').text(
					slide.next().data('pos')
				);

				//Footer
				if(slide.next().data('caption')){
					t.siblings('.slider-footer').find('.slider-footer_title').html(
						slide.next().data('caption')
					);
				}

				//Items
				var time = 200,
					 items_active = $S.parent().find('.slider-footer_item:visible'),
					 items_target = $S.parent().find('.slider-footer_item[data-pos="'+slide.next().data('pos')+'"]'),
					 button = slide.parents('.slider-mobile').find('.trigger-sound');
				showItems(items_active, items_target, button, time)
				showSoundButton(button, video, items_active, time)

			}
		});
	}
	function prevSlide(){
		$S.each(function(){
			var t = $(this);
			if(t.length && t.parent().hasClass('focus') && !t.hasClass('transition')){
				var slide = t.find('.slide:last-child'),
					 video = slide.find('.thumb');

				t.addClass('transition')
				 .prepend(slide)
				 .css('left', '-100%').animate({
					'left': '0'
				}, speed2, ease, function(){
					t.removeClass('transition');
					pauseVideos(video)
				});
				playVideos(video)

				//Count
				t.parent().find('.slider-count span').text(
					slide.data('pos')
				);

				//Footer
				if(slide.data('caption')){
					t.siblings('.slider-footer').find('.slider-footer_title').html(
						slide.data('caption')
					);
				}

				//Items
				var time = 200,
					 items_active = $S.parent().find('.slider-footer_item:visible'),
					 items_target = $S.parent().find('.slider-footer_item[data-pos="'+slide.data('pos')+'"]'),
					 button = slide.parents('.slider-mobile').find('.trigger-sound');
				showItems(items_active, items_target, button, time)
				showSoundButton(button, video, items_active, time)

			}
		});
	}

	/* Sliders
	==================================== */
	function checkKey(e){
		e = e || window.event;
		if(e.keyCode == '37'){
			if($F.length && window.innerWidth > 834){
				prevSlideFade()
			}
			if($S.length && window.innerWidth <= 834){
				prevSlide()
			}

		}else if(e.keyCode == '39'){
			if($F.length && window.innerWidth > 834){
				nextSlideFade()
			}
			if($S.length && window.innerWidth <= 834){
				nextSlide()
			}
		}
	}

	/* Video Sound
	==================================== */
	function muteVideos(button, video){
		if($('video').length){
			$('video').not(video).each(function(){
				$(this).prop('muted', true)
			});
			if($('.trigger-sound.active').not(button).length){
				$('.trigger-sound.active')
				 .not(button)
				 .removeClass('active')
				 .find('[data-lang="en"]').text('SOUND ON')
				 .next().text('ACTIVER LE SON')
			}
		}
	}
	function soundVideo(button, video){
		muteVideos(button, video)
		button.toggleClass('active')
				.find('[data-lang="en"]').text(
					button.find('[data-lang="en"]').text() == 'SOUND OFF' ? 'SOUND ON' : 'SOUND OFF'
				).next().text(
					button.find('[data-lang="fr"]').text() == 'DÉSACTIVER LE SON' ? 'ACTIVER LE SON' : 'DÉSACTIVER LE SON'
				)
		video.prop('muted', !video.prop('muted'));
	}
	function toggleVideosOrientation(){
		if(b.hasClass('template-index')){
			var target = $('.module-carrousel_block.single'),
				 button = target.find('.trigger-sound');
		}else{
			var target = $('.module-slider:only-child .slide.landscape.video-responsive'),
				 button = $('.trigger-sound');
		}
		if(target.find('.thumb').is('video')){
			target.each(function(){
				var t = $(this),
					 port = t.find('video').first(),
					 land = t.find('video').last();
				if(port.length && land.length){
					if(window.innerWidth > 834){
						port[0].pause();
						port.prop('muted', true)
						land[0].play()
					}else{
						land[0].pause();
						land.prop('muted', true)
						port[0].play()
					}
					// if(window.innerWidth == 834){
					// 	button
					// 		.removeClass('active')
					// 		.find('[data-lang="en"]').text('SOUND ON')
					// 		.next().text('ACTIVER LE SON')
					// }
				}
			})
		}
	}
	$('.trigger-sound').click(function(){
		var button = $(this)
			 video = button.parents('.module-wrapper').find('video:visible');
		soundVideo(button, video)
	})
	$('div.module-carrousel_block-thumbnails video, .module-slider:only-child .slide.landscape.video-responsive .thumb.sound').click(function(){
		var video = $(this),
			 button = video.parents('.module-wrapper').find('.trigger-sound');
		soundVideo(button, video)
	});

	/* Product gallery videos
	==================================== */
	function checkProductGalleryVideos(){
		if(window.innerWidth > 834){
			if($('#product-gallery video').length){
				$('#product-gallery video').each(function(){
					let video = $(this);
					if(video[0].paused){
						let playPromise = video[0].play();
						if(playPromise !== undefined){
							playPromise.then(_ => {
								console.log('Play promise succeeded');
								video.removeClass('is-paused autoplay-failed');
							}).catch(error => {
								console.log(error);
								video.addClass('autoplay-failed');
							});
						}else{
							console.log('Play promise failed');
							video.addClass('autoplay-failed');
						}
					}else{
						return false;
					}
				});
			}
		}else{
			if($('#product-gallery video').length){
				$('#product-gallery video').each(function(){
					let video = $(this);
					if(!video.parent().is(':first-child') && !video[0].paused){
						console.log('Video paused');
						video.addClass('is-paused')[0].pause();
					}else{
						return false;
					}
				});
			}
		}
	}

	/* Device detection
	==================================== */
	const isMobile = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

	if(isMobile){

		//If device
		b.addClass('mobile');

		//Pseudoclass :active on devices
		document.addEventListener('touchstart', function(){}, {passive: true});

		// Resize functions
		screen.orientation.addEventListener('change', function(e){
			heightViewport();
			toggleVideosOrientation();
			checkProductGalleryVideos();
		});

		//Slider
		if($S.length){
			let tsX = 0,
				 teX = 0;
			$('.slider-mobile').each(function(){
				var t = $(this),
					 s = t.find('.slider-track');
				t.bind('touchstart', function(event){
					console.log('')
					tsX = event.changedTouches[0].screenX;
					if(!t.hasClass('focus')){
						$('.focus').removeClass('focus')
						t.addClass('focus');
					}
				}).bind('touchend', function(event){
					teX = event.changedTouches[0].screenX;
					if(teX <= tsX && (tsX - teX > 50)){
						nextSlide()
					}
					if(teX >= tsX && (teX - tsX > 50)){
						prevSlide()
					}
				})
			});
		}

	}else{

		//if Desktop
		b.addClass('desktop');

		//Resize Functions
		var n = '';
		$(window).resize(function(){
			heightViewport();
			toggleVideosOrientation();
			checkProductGalleryVideos();
		});

		//Slider
		document.onkeydown = checkKey;

		//Cursor
		if(cursor.length){
			if(b.hasClass('template-product')){
				$('#product-gallery').on('mouseenter', function(){
					if(window.innerWidth > 834){
						cursor.show();
					}
				}).on('mousemove', function(e){
					if(window.innerWidth > 834){
						cursor.css({
							left: e.clientX,
							top: e.clientY
						});
					}
				}).on('mouseleave', function(e){
					cursor.hide();
				});
			}else{
				$('[data-cursor]').on('mouseenter', function(){
					cursor.html($(this).data('cursor')).show();
				}).on('mousemove', function(e){
					cursor.css({
						left: e.clientX,
						top: e.clientY
					});
				}).on('mouseleave', function(e){
					cursor.html('').hide();
				});
			}
			$(document).on('mouseleave', function(e){
				cursor.hide();
			});
		}

		//Draggable
		var p,
			 drag = $('.draggable');
		if(drag.length){
			drag.each(function(){
				var t = $(this);
				t.draggable({
					start: function(e, ui){
						p = $(this).scrollLeft();
					},
					drag: function(e, ui){
						$(this).scrollLeft(p + ui.position.left * -1);
					},
					addClasses: false
				});
			})
		}
	}

	/* Clearing format
	==================================== */
	if($('.clear-format').length){
		$('.clear-format').html(function(i, html){
			return html.replace(/&nbsp;/g, ' ');
		});
		$('.clear-format *:not(.exclude):not(br):not(table)').each(function(){
			$(this).filter(function(){
				return $(this).text().trim().length == 0;
			}).remove();
		});
	}

	/* Loader
	==================================== */
	heightViewport()
	setTimeout(function(){
		$('#loader').fadeOut(speed);
	}, speed);

	/* Cookies
	==================================== */
	const cookies = $('#cookies');
	if(localStorage.getItem('cookies') === 'true'){
		cookies.remove()
	}
	$('#cookies-close').click(function(){
		localStorage.setItem('cookies', true);
		cookies.animate({
			opacity: 0,
			queue: false
		}, speed2, ease, function(){
			cookies.slideUp(speed2, ease, function(){
				cookies.remove()
			})
		});
	});

	/* Menu
	======================================== */
	function toggleMenu(){
		if(window.innerWidth <= 834){
			$('header').toggleClass('active');
			$('menu').fadeToggle(speed2, ease);
		}
	}
	$('#trigger-menu, #menu-close, menu a[data-lang]').click(function(){
		toggleMenu()
	});

	/* Minicart
	==================================== */
	const cart = $('#minicart-wrapper');
	function toggleCart(){
		if(!cart.hasClass('transition')){
			b.toggleClass('popup-open')
			$('#trigger-cart').toggleClass('active')
			if(window.innerWidth > 834){
				cart.toggle('slide', {
					direction: 'right',
					speed: speed*2,
					easing: 'easeInOutQuart',
					complete: function(){
						cart.removeClass('transition')
					}
				})
			}else{
				cart.fadeToggle(speed2, ease, function(){
					cart.removeClass('transition')
				})
			}
		}
	}
	$('#trigger-cart, #mincart-close').click(function(e){
		e.stopPropagation()
		toggleCart()
	})
	cart.click(function(e){
		e.stopPropagation()
	});
	$(document).click(function(){
		if(b.hasClass('popup-open')){
			toggleCart()
		}
	})

	const body = $('body');

	/* Popups
	======================================== */
	function showPopup(popup, timer){
		setTimeout(function(){
			body.addClass('transition');
			popup
				.fadeIn(speed*2, function(){
					popup.find('fieldset:first-of-type input')?.focus();
					body.removeClass('transition');
				}).addClass('completed');
		}, timer);
	}

	function hidePopup(popup){
		body.addClass('transition');
		popup
			.removeClass('completed')
			.fadeOut(speed*2, function(){
				body.removeClass('transition');
			});
	}

	$('[data-popup]').click(function(){
		showPopup($($(this).data('popup')), 0);
	});

	$('.popup-wrapper').click(function(){
		hidePopup($(this));
	}).find('.popup').click(function(e){
		e.stopPropagation();
	}).find('.popup-close').click(function(){
		hidePopup($(this).closest('.popup-wrapper'));
	});

	if(!isMobile){
		$(document).on('keydown', function(e){
			if(e.key === 'Escape'){
				let activePopup = $('.popup-wrapper:visible');
				if(activePopup.length){
					hidePopup(activePopup);
					if(activePopup.is('#popup-newsletter')){
						sessionStorage.setItem('popup-newsletter', 'close');
					}
				}
			}
		});
	}

	/* Newsletter
	======================================== */
	const newsletter = $('#popup-newsletter');
	if(newsletter.length){
		if(sessionStorage.getItem('popup-newsletter') == 'close'){
			newsletter.remove();
		}else{

			if(
				newsletter.find('.error').length
			|| newsletter.find('.success').length
			){
				newsletter
					.addClass('completed')
					.show();
			}else{
				let newsletterTimer = newsletter.data('timer')*1000;
				if(newsletterTimer > 0){
					showPopup(newsletter, newsletterTimer);
				}else{
					newsletter
						.addClass('completed')
						.show();
				}
				
			}

			newsletter.click(function(){
				sessionStorage.setItem('popup-newsletter', 'close');
			}).find('.popup-close').click(function(){
				sessionStorage.setItem('popup-newsletter', 'close');
			});

		}

	}

	/* Notify me
	======================================== */
	$('#form-notifyme').submit(function(e){
		e.preventDefault();
		let t = $(this);
		let input = t.find('input');
		let button = t.find('button');
		body.addClass('transition');
		setTimeout(function(){
			if($('#newsletter-signpopup').length && $('#newsletter-signpopup input[type="email"]').val() == input.val()){
				$('#newsletter-signpopup input[type="button"]').click();
				t.removeClass('error').addClass('success');
				input.blur().css('pointer-events', 'none');
				button.attr('disabled', true);
			}else{
				t.addClass('error');
				input.focus().val('');
			}
			body.removeClass('transition');
		}, 2000);
	});
	$('#form-notifyme input[type="email"]').keyup(function(){
		$('#newsletter-signpopup input[type="email"]')?.val($(this).val());
	});

	/* Forms
	==================================== */
	$('.module-form fieldset:first-of-type input').keyup(function(){
		let t = $(this);
		let button = t.siblings('button');
		if(button.length){
			if(t.val() != ''){
				button.fadeIn(speed);
			}else{
				button.fadeOut(speed);
			}
		}
	});

	$('[data-placeholder]').each(function(){
		var t = $(this),
			 p = t.data('placeholder'),
			 b = t.next('button');
		t.click(function(){
			t.attr('placeholder', '')
		}).blur(function(){
			t.attr('placeholder', p)
		}).keyup(function(){
			if(t.val() != ''){
				if(b.hasClass('clear')){
					b.removeClass('clear')
					 .text('↗')
				}else{
					b.fadeIn(speed)
				}
			}else{
				b.fadeOut(speed)
			}
		});
	});
	$('.module-search button').click(function(e){
		var t = $(this);
		if(t.hasClass('clear')){
			e.preventDefault()
			$('.module-search button').fadeOut(speed, function(){
				$('.module-search button').removeClass('clear')
				 .text('↗')
				 .prev('input').val('')
			})
		}
	});

	/* Switch cols
	==================================== */
	if(sessionStorage.getItem('view-mode') === 'grid'){
		$('[data-view="grid"]').addClass('active').siblings().removeClass('active')
		$('.module-products_products').attr('data-mode', 'grid');
	}
	$('[data-view]').click(function(){
		var t = $(this),
			 mode = t.data('view')
		$(window).scrollTop(0);
		t.addClass('active').siblings().removeClass('active')
		sessionStorage.setItem('view-mode', mode);
		$('.module-products_products').attr('data-mode', mode);
	});

	/* Sections
	==================================== */
	//Product
	$('.trigger').click(function(){
		var t = $(this),
			 s = t.find('span').last()
			 n = t.next('.collapsed');
		if(n.length){
			if(!t.hasClass('transition')){
				t.addClass('transition')
				if($('.trigger + .collapsed').not(n).is(':visible')){
					$('.trigger').removeClass('active')
					$('.trigger + .collapsed:visible').slideUp(speed, ease, function(){
						t.addClass('active')
						n.slideDown(speed, ease, function(){
							t.removeClass('transition')
						});
					});
				}else{
					t.toggleClass('active')
					n.slideToggle(speed, ease, function(){
						t.removeClass('transition')
					});
				}
			}
		}
	})
	//Footer
	$('.trigger-footer').click(function(){
		var t = $(this),
			 s = t.find('span').last()
			 n = t.next('.collapsed');
		if(n.length){
			if(!t.hasClass('transition')){
				t.addClass('transition')
				if($('footer .collapsed').not(n).is(':visible')){
					$('.trigger-footer').removeClass('active')
					$('footer .collapsed:visible').slideUp(speed, ease, function(){
						t.addClass('active')
						n.slideDown(speed, ease, function(){
							t.removeClass('transition')
						});
						$('html, body').animate({
							scrollTop: $(document).height()
						}, speed, ease)
					});
				}else{
					t.toggleClass('active')
					n.slideToggle(speed, ease, function(){
						t.removeClass('transition')
					});
					if(t.hasClass('active')){
						$('html, body').animate({
							scrollTop: $(document).height()
						}, speed, ease)
					}
				}
			}
		}
	})

	/* Filters Wrapper
	==================================== */
	function openFilters(t, n, o){
		if(window.innerWidth > 600){
			n.stop()
			 .animate({
				width: 'toggle'
			}, speed2, ease, function(){
				// n.stop()
				//  .animate({
				// 	opacity: 1
				// }, speed2, ease, function(){
					t.removeClass('transition')
				// })
			});
		}else{
			n.stop()
			 .animate({
				height: 'toggle',
				// opacity: o
			}, speed2, ease, function(){
				t.removeClass('transition')
			})
		}
	}
	$('.trigger-filters').click(function(){
		var t = $(this),
			 n = t.next('.collapsed'),
			 o = 0;
		if(n.length && !$('.trigger-filters').hasClass('transition')){
			t.addClass('transition')
			if($('.filters-wrapper .collapsed').not(n).is(':visible')){
				$('.trigger-filters').not(t).removeClass('active')
				if(window.innerWidth > 600){
					$('.filters-wrapper .collapsed:visible').stop().animate({
						width: 'toggle',
						// opacity: 0
					}, speed2, ease, function(){
						t.addClass('active')
						openFilters(t, n, o)
					})
				}else{
					$('.filters-wrapper .collapsed:visible').stop().animate({
						height: 'toggle',
						// opacity: 0
					}, speed2, ease, function(){
						o = 1;
						t.addClass('active')
						openFilters(t, n, o)
					})
				}
			}else{
				t.toggleClass('active')
				if(window.innerWidth > 600){
					if(t.hasClass('active')){
						openFilters(t, n, o)
					}else{
						n.stop()
						 .animate({
							width: 'toggle',
							// opacity: 0
						}, speed2, ease, function(){
							t.removeClass('transition')
						})
					}
				}else{
					// if(t.hasClass('active')){
					// 	o = 1
					// }
					openFilters(t, n, o)
				}
			}
		}
	});

	/* Filters
	==================================== */
	$('.filter').click(function(){
		var t = $(this),
			 active = t.parents('.filters-wrapper').find('input'),
			 type = t.data('type'),
			 val = t.data('filter');

		//Pos
		$(window).scrollTop(0);

		//Active/deactive filter
		t.toggleClass('active');

		//Hide projects
		$('.product').addClass('active-'+type);

		//Filter
		active.addClass('active').toggleClass(val);
		var fa = active.attr('class'),
			 ca = fa.split(/\s+/);
		$.each(ca, function(index, v){
			$('.product' + v).removeClass('active-'+type);
		});

		//Clear
		if($('.filter[data-type="'+type+'"].active').length == 0){
			$('.product').removeClass('active-'+type);
			active.removeClass('active')
		}

	});

	/* Slider
	==================================== */
	function focusSlider(t){
		if(!t.parent().hasClass('focus')){
			$('.focus').removeClass('focus')
			t.parent().addClass('focus')
		}
	}
	$('.slider-mobile').first().addClass('focus');
	$('.slider-mobile .next').click(function(){
		focusSlider($(this))
		nextSlide();
	});
	$('.slider-mobile .prev').click(function(){
		focusSlider($(this))
		prevSlide();
	});
	$('.slider .next').click(function(){
		nextSlideFade();
	});
	$('.slider .prev').click(function(){
		prevSlideFade()
	});

	/* Lightbox
	==================================== */
	$('#product-gallery .thumb').click(function(){
		var t = $(this),
			 g = $('#product-gallery');
		if(window.innerWidth > 834){
			if(!b.hasClass('lightbox-active')){
				b.addClass('lightbox-active')
				g.scrollTop(
					g.scrollTop() + t.position().top + t.height()/2 - window.innerHeight/2
				);
			}else{
				b.removeClass('lightbox-active');
				$('html, body').animate({
					scrollTop: t.offset().top - 2
				}, 0);
			}
		}
	});
	$('#close-lightbox').click(function(){
		b.removeClass('lightbox-active');
		$(window).scrollTop(0);
	})

	/* Lazy Loading
	==================================== */
	function lazyLoading(t){
		if(t.tagName == 'IMG'){
			t.src = t.dataset.src;
		}
		if(t.tagName == 'VIDEO'){
			var P = t.play();
			if(P !== undefined){
				P.catch(error => {
					if($(t).hasClass('gif')){
						t.classList.add('no-autoplay');
					}else{
						t.classList.add('controls');
						t.controls = true;
					}
				});
			}
		}
		if($(t).hasClass('delay')){
			setTimeout(function(){
				t.classList.remove('lazy');
				setTimeout(function(){
					$(t).parent().addClass('loaded');
				}, speed*2)
			}, speed*2)
		}
	}

	/* Observer Functions
	==================================== */
	var L = [].slice.call(document.querySelectorAll('.lazy'));
	if('IntersectionObserver' in window){
		let l = new IntersectionObserver(function(E, observer){
			E.forEach(function(e){
				if(e.isIntersecting){
					let t = e.target;
					lazyLoading(t)
					l.unobserve(t);
				}
			});
		});
		L.forEach(function(t){
			l.observe(t);
		});
	}else{
		L.forEach(function(t){
			lazyLoading(t)
		});
	}

});
